const siteName = (prefix) => `${prefix} - Kenai`

export default siteName
